<template>
	<v-card class="background darken-1">
		<v-card-title class="py-2 elevation-4">
			<slot name="card-title"></slot>
		</v-card-title>
		<v-card-text class="form" v-if="mode === 'form'">
			<component
				:is="form_component"
				class="mx-3"
				:details="parameters || {}"
				:param="param"
				:parameters="parameters"
				:debug="false"
				:visible="true"
				ref="unitary_form_component"
				:dense="dense"
				:wf_data="jd"
				:form="forms[0]"
				:groups="groups"
				:groups_order="groups_order"
				:groups_collapse="groups_collapse"
				@modal_width="$emit('modal-width', $event)"
				@change="forms = $event">
			</component>
		</v-card-text>

		<v-card-text class="form" v-else-if="mode === 'raw'">
			<LauncherRaw :form="forms[0]">
			</LauncherRaw>
		</v-card-text>

		<v-card-actions class="elevation-4">
			<!-- <v-switch
				label="Dense"
				v-model="dense"
				class="mt-0 ml-2"
				color="primary"
				hide-details>
			</v-switch> -->
			<v-btn
				flat
				v-if="mode === 'form' && is_admin"
				color="primary"
				class="text-none"
				@click="mode = 'raw'">
				<v-icon class="mr-2">data_object</v-icon>
				Edition brute
			</v-btn>
			<v-btn
				flat
				v-else-if="mode === 'raw' && is_admin"
				color="primary"
				class="text-none"
				@click="mode = 'form'">
				<v-icon class="mr-2">format_list_bulleted</v-icon>
				Form
			</v-btn>
			<v-btn
				flat
				color="primary"
				class="text-none"
				@click="$emit('edit-batch', forms[0].parameters)">
				<v-icon class="mr-2" large>playlist_play</v-icon>
				Editer un batch
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				v-if="follow_jr"
				flat
				color="yellow accent-3"
				class="text-none"
				@click="follow_jr = !follow_jr">
				<v-icon class="mr-1">star</v-icon>
				Job suivi
			</v-btn>
			<v-btn
				v-else
				flat
				color="background lighten-5"
				class="text-none"
				@click="follow_jr = !follow_jr">
				<v-icon class="mr-1">star_outline</v-icon>
				Suivre le job
			</v-btn>
			<v-btn
				color="primary color--text"
				class="text-none"
				:loading="submitting"
				:disabled="invalid"
				@click="launchJob()">
				<v-icon class="mr-2" large>play_arrow</v-icon>
				Démarrer le job
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import LauncherRaw from '@/pages/maestro/launcher/forms/launcher_form_raw.vue'
import maestroInitForm from '@/pages/maestro/launcher/forms/launcher_form.vue'
import maestroInitFormAudioToolsAudioFiles from '@/pages/maestro/launcher/forms/launcher_form_audiotools_audiofiles.vue'
import maestroInitFormSuifileFvodServ from '@/pages/maestro/launcher/forms/launcher_form_suifile_fvodserv.vue'
import maestroInitFormLagardere from '@/pages/maestro/launcher/forms/launcher_form_lagardere.vue'
import maestroInitFormAmazonPackageGlobal from '@/pages/maestro/launcher/forms/launcher_form_amazon_package_global.vue'
import maestroInitFormXboxPackage from '@/pages/maestro/launcher/forms/launcher_form_xbox_package.vue'
import maestroInitFormGenericVantageJob from '@/pages/maestro/launcher/forms/launcher_form_generic_vantage_job.vue'
import maestroInitFormDVDBD from '@/pages/maestro/launcher/forms/launcher_form_dvd_bd.vue'
import maestroInitFormLegacy from '@/pages/maestro/launcher/forms/launcher_form_legacy.vue'
import maestroInitFormLegacyArchiveContract from '@/pages/maestro/launcher/forms/launcher_form_legacy_archive_contract.vue'
import maestroInitFormDCP from '@/pages/maestro/launcher/forms/launcher_form_dcp.vue'

export default {
	props: [ 'jd', 'param', 'parameters', 'parent_jr_id', 'dialog' ],
	components: {
		LauncherRaw,
		maestroInitForm,
		maestroInitFormAudioToolsAudioFiles,
		maestroInitFormSuifileFvodServ,
		maestroInitFormAmazonPackageGlobal,
		maestroInitFormXboxPackage,
		maestroInitFormGenericVantageJob,
		maestroInitFormLagardere,
		maestroInitFormDVDBD,
		maestroInitFormLegacy,
		maestroInitFormLegacyArchiveContract,
		maestroInitFormDCP
	},
	data () {
		return {
			form_component: null,
			dense: false,
			forms: [],
			groups: {
				default: []
			},
			follow_jr: false,
			groups_order: [],
			groups_collapse: {},
			mode: 'form',
			is_admin: this.$user.isAdmin(),
			submitting: false
		}
	},
	computed: {
		invalid () {
			for (const form of this.forms) {
				if (!form.isValid) return true
			}
			if (this.forms.length === 0) return true
			return false
		}
	},
	watch: {
		dialog (val) {
			if (val) this.init()
		}
	},
	methods: {
		async launchJob () {
			let valid = this.$refs.unitary_form_component.validate()
			if (!valid) {
				let inputs = this.$refs.unitary_form_component.$refs.unitary_form.inputs
				let errorContent = '<ul>'
				inputs.map(input => {
					if (input.hasError) {
						let name = input.$attrs.name
						let error = input.errorBucket[0]
						errorContent += `<li>${name}: ${error}</li>`
					}
				})
				errorContent += '</ul>'
				this.$Toaster({
					title: 'Paramêtres de lancement incomplets',
					content: errorContent,
					type: 'error',
					loading: false,
					timeout: 0
				})
				return
			}
			let forms = JSON.parse(JSON.stringify(this.forms))
			// Special case for multi_jobs demux on one parameter
			let multiJobsCase = this.$refs.unitary_form_component.multiple_jobs &&
				this.$refs.unitary_form_component.multiple_jobs_key
			if (multiJobsCase) {
				forms = this.forms[0].parameters[this.$refs.unitary_form_component.multiple_jobs_key].map(item => {
					let form = JSON.parse(JSON.stringify(this.forms[0]))
					form.parameters[this.$refs.unitary_form_component.multiple_jobs_key] = [ item ]
					return form
				})
			}
			this.submitting = true
			let errors = []
			for (const form of forms) {
				let data = {
					jd_id: this.jd.descriptor_id,
					jd_version: this.jd.version_number,
					parameters: form.parameters
				}
				if (this.parent_jr_id) {
					data.parent_jobrequest_id = this.parent_jr_id
				}
				try {
					let response = await this.$ApiMaestro.jobrequest_create(data)
					if (this.$commons.checkResponse(response)) {
						if (response.data.created) {
							let content = `<a href="/maestro/job/${response.data.created}" target="_blank">
								<button type="button"
									color="black"
									class="text-none v-btn v-btn--block mt-4 v-btn--outline black--text">
									<div class="v-btn__content">
										<i data-v-d38fa73c="" aria-hidden="true" class="v-icon mr-2 material-icons theme--dark">
											link
										</i>
										Job #${response.data.created}
									</div>
								</button>
							</a>`
							this.$Toaster({
								title: `${this.jd.label} lancé`,
								content: content,
								type: 'success',
								loading: false,
								timeout: 5000
							})
							if (multiJobsCase) {
								this.forms[0].parameters[this.$refs.unitary_form_component.multiple_jobs_key].shift()
							}
						}
						if (response.data.created && this.follow_jr) {
							setTimeout(() => {
								this.$Bus.$emit('follow-jrs', [response.data.created])
							}, 2000)
						}
					}
				} catch (error) {
					console.error(error)
					if (error.response) {
						errors.push(error.response.statusText)
						Object.keys(error.response.data).map(key => {
							error.response.data[key].map(err => {
								errors.push(err)
							})
						})
					} else {
						errors.push(error.message)
					}
				}
			}
			this.submitting = false
			if (errors.length) {
				let errorContent = '<ul>'
				errors.map(error => { errorContent += `<li>${error}</li>` })
				errorContent += '</ul>'
				this.$Toaster({
					title: 'Erreur lors du lancement',
					content: errorContent,
					type: 'error',
					loading: false,
					timeout: 0
				})
			} else {
				this.$nextTick(() => {
					this.init()
					this.$emit('close')
				})
			}
		},
		init () {
			this.forms = []
			this.groups = { default: [] }
			this.groups_order = []
			this.groups_collapse = {}
			if (this.jd.parameters) {
				let form = { isValid: true, parameters: {} }
				for (const parameter of this.jd.parameters) {
					// Build Groups
					if (!parameter.group) {
						this.groups.default.push(parameter)
						if (this.groups_order.indexOf('default') === -1) {
							this.groups_order.push('default')
							this.$set(this.groups_collapse, 'default', true)
						}
					} else {
						if (!this.groups[parameter.group]) {
							this.groups[parameter.group] = []
							this.groups_order.push(parameter.group)
							this.$set(this.groups_collapse, parameter.group, true)
						}
						this.groups[parameter.group].push(parameter)
					}
					// Build Form
					let paramValue = ''
					if ((this.parameters || {}).hasOwnProperty(parameter.name)) {
						if (parameter.type === 'json' &&
							this.parameters[parameter.name] instanceof Object) {
							paramValue = JSON.stringify(
								this.parameters[parameter.name],
								null,
								2
							)
						} else {
							paramValue = this.parameters[parameter.name]
						}
					} else {
						let defaultValue = parameter.default
						if (defaultValue) {
							if (['[', '{'].indexOf(defaultValue[0]) === 0 &&
									[']', '}'].indexOf(defaultValue[defaultValue.length - 1]) === 0) {
								try {
									defaultValue = JSON.parse(defaultValue.replace(/'/g, '"'))
								} catch (error) {
									console.log(error)
								}
							}
							if (parameter.type === 'text') {
								defaultValue = defaultValue.replace(/\\n/g, '\n')
							}
							if (['babelid', 'bundleid'].indexOf(parameter.type) > -1) {
								defaultValue = parseInt(defaultValue)
							}
							if (['multi-babelid', 'multi-bundleid'].indexOf(parameter.type) > -1) {
								defaultValue = defaultValue.map(item => parseInt(item))
							}
						} else {
							if (parameter.type.indexOf('multi-') === 0) defaultValue = []
							if (parameter.type.indexOf('json') === 0) defaultValue = '{}'
						}
						if (this.param) {
							if (this.param.type.indexOf(parameter.type) > -1) {
								defaultValue = this.param.value
							}
						}
						paramValue = defaultValue
					}
					form.parameters[parameter.name] = paramValue
				}
				this.$set(this.forms, 0, form)
			}
			this.$nextTick(() => {
				if (this.$refs.unitary_form_component) {
					this.$refs.unitary_form_component.resetValidation()
					if (this.$refs.unitary_form_component.init) {
						this.$refs.unitary_form_component.init()
					}
				}
			})
		}
	},
	mounted () {
		this.init()
		if (this.jd.descriptor_id) {
			for (var key in window.appConfig.maestro_wf) {
				let currentId = window.appConfig.maestro_wf[key].id
				if (currentId) {
					currentId = parseInt(currentId)
					if (currentId === this.jd.descriptor_id) {
						this.form_component = window.appConfig.maestro_wf[key].initForm
						break
					}
				}
			}
			if (!this.form_component) {
				this.form_component = 'maestroInitForm'
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.form
	border-top: 0.5px solid var(--v-background-base)
	border-bottom: 0.5px solid var(--v-background-base)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_unitary.vue